import * as JsonFormatter from 'spark-util/JsonObjectFormatter';
import get from 'lodash/get';
import { formatDateTime } from 'spark-util/dateUtils';
import { transform } from 'spark-util/fpUtils';

const SET_REPORT_TYPES_LIST = 'REPORT_TYPE.SET_REPORT_TYPES_LIST';
const SET_REPORT_TYPE_BY_ID = 'REPORT_TYPE.SET_REPORT_TYPES_BY_ID';
const SET_REPORT_TYPE_ROLES = 'REPORT_TYPE.SET_REPORT_TYPE_ROLES';
const SET_REPORT_TYPE_GLOBAL_ROLES='SET_REPORT_TYPE_GLOBAL_ROLES';
const SET_EMAIL_LANGUAGE = 'SET_EMAIL_LANGUAGE'; 
const SET_ACK_EXCLUSION_CONFIG = 'REPORT_TYPE.SET_ACK_EXCLUSION_CONFIG'; 

export const getReportTypeById = (state, id) => getAvailableReportTypes(state)[id];
export const getAvailableReportTypes = (state) => state.config.reportTypes;
export const getReportTypeFormDetails = (state, id) => get(state, `config.reportTypeById[${id}]`);
export const getAllRoles = (state, value) => get(state, `config.${value}`);
export const getReport = (state, id) => get(state, `config.reportTypes[${id}]`);
export const getAllEmailLanguages = (state, value) => get(state, `config.${value}`); //SAF-18752 getting all email languages
export const getAckExclusionConfigData = (state, id) => get(state, `config.ackExclusionConfig[${id}]`);

export const setReportTypes = (response) => ({ type: SET_REPORT_TYPES_LIST, response });
export const setCountrySpecificDetailsById = (reportTypeConfigId, response) => ({
	type: SET_REPORT_TYPE_BY_ID,
	reportTypeConfigId,
	response
});
export const setRoles = (response) => ({ type: SET_REPORT_TYPE_ROLES, response });

/**
 * To save Global Roles Data to redux store (State) we are defining action type
 * Relase 6.5
 * Author: Sourabh
**/
export const setGlobalRoles = (response) => ({ type: SET_REPORT_TYPE_GLOBAL_ROLES, response });
export const setEmailLanguage = (response) => ({
	type: SET_EMAIL_LANGUAGE,
	response
});
/**
 * SAF-20860- Save and Edit Functionalities for Process for sites not requiring Acknowledge for Future Safety Letters
 * To save Acknowledgement Exclusion Configuration data to redux store for edit report type
 * Relase 9.0
 * Author: Sourabh
**/
export const setAckExclusionConfig = (reportTypeConfigId, response) => ({
	type: SET_ACK_EXCLUSION_CONFIG,
	reportTypeConfigId,
	response
});

// Initial component state
const initialState = {
	reportTypes: {
		//[reportTypeConfigId]: reportTypes
	},
	reportTypeById: {},
	ackExclusionConfig: {}
};
//Redux state exposure

export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_REPORT_TYPES_LIST: {
			return {
				...state,
				reportTypes: JsonFormatter.arrayToObject(
					'reportTypeConfigId',
					get(action.response, 'data.content', []).map(formatReportTypeDates)
				)
			};
		}
		case SET_REPORT_TYPE_ROLES: {
			return {
				...state,
				loadrolesData: action.response
			};
		}
		/* based on type we are setting global roles to a variable loadGlobaleRolesData in reducer */
		case SET_REPORT_TYPE_GLOBAL_ROLES: {

            return {

                ...state,

                loadGlobalRolesData: action.response

            };

        }
		case SET_REPORT_TYPE_BY_ID: {
			const { reportTypeConfigId, response } = action;
			return Object.assign({}, state, {
				reportTypeById: {
					[reportTypeConfigId]: response.data
				}
			});
		}
		// SAF-18752: To set email language data in redux store
		case SET_EMAIL_LANGUAGE: {
			return {
				...state,
				loadEmailLanguageData: Array.isArray(action.response)
					? action.response.sort((a, b) => a.label.localeCompare(b.label))
					: action.response
			};
		}
		case SET_ACK_EXCLUSION_CONFIG: {
			const { reportTypeConfigId, response } = action;
			return {
				...state,
				ackExclusionConfig: {
					...state.ackExclusionConfig,
					[reportTypeConfigId]: response.data
				}
			};
		}
		default:
			return state;
	}
};

const formatReportTypeDates = transform({
	modifiedDt: formatDateTime
});
